exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "html{background-color:#000}#router-view{margin-left:50px}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/App.vue"],"names":[],"mappings":"AACA,KACE,qBAAwB,CACzB,AACD,aACE,gBAAkB,CACnB","file":"App.vue","sourcesContent":["\nhtml {\n  background-color: black;\n}\n#router-view {\n  margin-left: 50px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e1b3a70","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 975
// module chunks = 6